export const NEWS_LETTER_ERROR_CODES = {
	1301: 'newsletter_error_incorrect_email',
	1302: 'newsletter_error_incorrect_hash_list',
	1303: 'newsletter_error_incorrect_fields',
	1304: 'newsletter_error_subscriber_exists',
	1305: 'newsletter_error_invalid_subscriber_status'
};

export const DEFAULT_NEWSLETTER_ERROR_MESSAGE = NEWS_LETTER_ERROR_CODES[1305];
